// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","mode":"Header_mode__Wa2BX","active":"Header_active__rHuVo","input":"Header_input__-6RIz","search":"Header_search__eTOfB","btn":"Header_btn__INAxa"};